import * as tslib_1 from "tslib";
import { NotificationsApi } from '@api/notifications.api';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { sentry } from 'sentry';
import { ConfirmDialogService } from '../../../../@fuse/components/confirm-dialog/confirm-dialog.service';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "../../../../@fuse/services/translation-loader.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../api/notifications.api";
import * as i4 from "../../../../@fuse/components/confirm-dialog/confirm-dialog.service";
var PushNotificationsService = /** @class */ (function () {
    function PushNotificationsService(fuseTranslationLoaderService, translate, notificationsApi, confirmDialogService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translate = translate;
        this.notificationsApi = notificationsApi;
        this.confirmDialogService = confirmDialogService;
        this.subscriptionId = null;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    PushNotificationsService.prototype.refreshNotificationSubscription = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var permission, subscription, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.notificationsApi.syncUser()];
                    case 1:
                        _b.sent();
                        if (!this.isPushNotificationsAvailable()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.requestPermission()];
                    case 2:
                        permission = _b.sent();
                        if (!permission) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getSubscription()];
                    case 3:
                        subscription = _b.sent();
                        if (!subscription) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.notificationsApi.subscribe(subscription)];
                    case 4:
                        _a.subscriptionId = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PushNotificationsService.prototype.unsubscribe = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var reg, subscription;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.subscriptionId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.notificationsApi.unsubscribe(this.subscriptionId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.isPushNotificationsAvailable()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getServiceWorkerRegistration()];
                    case 3:
                        reg = _a.sent();
                        if (!reg) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, reg.pushManager.getSubscription()];
                    case 4:
                        subscription = _a.sent();
                        if (!subscription) return [3 /*break*/, 6];
                        return [4 /*yield*/, subscription.unsubscribe()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PushNotificationsService.prototype.requestPermission = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, permission;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Notification.permission === 'denied' || localStorage.getItem('showNotificationDialogAgain') === 'false') {
                            console.warn('The user has blocked notifications.');
                            this.dispatchDialogClosedEvent();
                            return [2 /*return*/, false];
                        }
                        if (!(Notification.permission === 'default')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.confirmDialogService.open({
                                title: this.translate.instant('TOOLBAR.NOTIFICATIONS.TITLE'),
                                okText: this.translate.instant('TOOLBAR.NOTIFICATIONS.CONFIRM_DIALOG.CONFIRM'),
                                cancelText: this.translate.instant('TOOLBAR.NOTIFICATIONS.CONFIRM_DIALOG.CANCEL'),
                                message: this.translate.instant('TOOLBAR.NOTIFICATIONS.MESSAGE'),
                                checkboxMessage: {
                                    message: this.translate.instant('TOOLBAR.NOTIFICATIONS.CONFIRM_DIALOG.CHECKBOX_MESSAGE'),
                                    show: true
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        this.dispatchDialogClosedEvent();
                        if (!result || !result.confirmed) {
                            console.warn('The user has rejected notifications.');
                            if (result && result.checked) {
                                localStorage.setItem('showNotificationDialogAgain', 'false');
                            }
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.dispatchDialogClosedEvent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, Notification.requestPermission()];
                    case 4:
                        permission = _a.sent();
                        return [2 /*return*/, permission === 'granted'];
                }
            });
        });
    };
    PushNotificationsService.prototype.getSubscription = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var registration, existingSubscription;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getServiceWorkerRegistration()];
                    case 1:
                        registration = _a.sent();
                        if (!registration) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 2:
                        existingSubscription = _a.sent();
                        if (existingSubscription) {
                            return [2 /*return*/, existingSubscription];
                        }
                        return [2 /*return*/, registration.pushManager
                                .subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: environment.VAPID_PUBLIC_KEY
                            })
                                .catch(function (err) {
                                console.warn('Error during getSubscription', err);
                                sentry.captureException(err);
                                return null;
                            })];
                }
            });
        });
    };
    PushNotificationsService.prototype.getServiceWorkerRegistration = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, navigator.serviceWorker.ready];
            });
        });
    };
    PushNotificationsService.prototype.isPushNotificationsAvailable = function () {
        return Boolean(navigator.serviceWorker && window['PushManager'] && environment.SERVICE_WORKER);
    };
    PushNotificationsService.prototype.dispatchDialogClosedEvent = function () {
        var event = new CustomEvent('push-notification-dialog-closed', {
            bubbles: true,
            composed: true
        });
        window.dispatchEvent(event);
    };
    PushNotificationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PushNotificationsService_Factory() { return new PushNotificationsService(i0.ɵɵinject(i1.FuseTranslationLoaderService), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.NotificationsApi), i0.ɵɵinject(i4.ConfirmDialogService)); }, token: PushNotificationsService, providedIn: "root" });
    return PushNotificationsService;
}());
export { PushNotificationsService };
